import api from ".";
import { IQuestionOption } from "../types/questionOption";
import cookiesModifier from "../utils/cookies";


export const getAllQuestionOptions = async () => {
    try {
        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`question-options`);

        return res.data as IQuestionOption[];
    } catch (error) {
        throw error;
    }
}

export const getQuestionOptions = async () => {
    try {
        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`question-options/tree`);

        return res.data as IQuestionOption[];
    } catch (error) {
        throw error;
    }
}

export const createQuestionOption = async (type: string) => {
    const url = `question-options`;
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
        const res = await api.post(url, { type });
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const updateQuestionOption = async (data: IQuestionOption) => {
    try {
        const payload = { type: data.type };
        const url = `question-options/${data.id}`;
        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.patch(url, payload);

        return res.status;
    } catch (error) {
        throw error;
    }
}

export const deleteQuestionOption = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`question-options/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}